import { useRef, useState } from "react";
import { createPortal } from "react-dom";

/* Collapsed sidebar: hover an icon → its name floats beside it (fixed, so the scrolling nav never clips it).
   Items with sub-panels (Documents) show a small clickable fly-out list. */
export const useSidebarHover = (enabled) => {
  const [hover, setHover] = useState(null);
  const t = useRef(null);
  const keep = () => { if (t.current) clearTimeout(t.current); };
  const hide = () => { keep(); t.current = setTimeout(() => setHover(null), 120); };
  const bind = (label, subs = null) => enabled ? {
    onMouseEnter: (e) => { keep(); const r = e.currentTarget.getBoundingClientRect();
      setHover({ label, subs, top: subs?.length ? r.top : r.top + r.height / 2, left: r.right + 10 }); },
    onMouseLeave: hide,
  } : {};
  const layer = enabled && hover ? createPortal(
    <div onMouseEnter={keep} onMouseLeave={hide} data-testid="sidebar-hover-label"
      className={`fixed z-[100] rounded-lg bg-slate-900 text-white shadow-xl animate-in fade-in-0 zoom-in-95 duration-100 ${hover.subs?.length ? "" : "-translate-y-1/2"}`}
      style={{ top: hover.subs?.length ? Math.min(hover.top, window.innerHeight - 40 - hover.subs.length * 26) : hover.top, left: hover.left }}>
      <span className={`absolute -left-1 h-2 w-2 rotate-45 bg-slate-900 ${hover.subs?.length ? "top-3" : "top-1/2 -translate-y-1/2"}`} />
      <div className="whitespace-nowrap px-3 py-1.5 text-xs font-semibold">{hover.label}</div>
      {hover.subs?.length > 0 && (
        <div className="border-t border-white/10 p-1">
          {hover.subs.map((s) => (
            <button key={s.id} type="button" onClick={() => { s.onPick(); setHover(null); }} data-testid={`sidebar-fly-${s.id}`}
              className={`flex w-full items-center gap-2 whitespace-nowrap rounded px-2 py-1 text-left text-xs ${s.active ? "bg-white/15 font-semibold" : "text-slate-200 hover:bg-white/10"}`}>
              <s.icon className="h-3.5 w-3.5" /> {s.label}
            </button>))}
        </div>)}
    </div>, document.body) : null;
  return { bind, layer };
};
